import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DCard from "../../components/card/DCard";
import DCardHeader from "../../components/card/DCardHeader";
import DCardBody from "../../components/card/DCardBody";
import Select from "react-select";
import InputMask from "react-input-mask";
import { Table } from "react-bootstrap";

import { clinicManifestations } from "../../../enum/enums";

const ClinicalManifestationCard = props => {
    const {
        children,
        className,
        //
        onRequestAdd,
        clinicalManifestationsListParm,
        ...attributes
    } = props;

    const [clinicalManifestationsList, setClinicalManifestationsList] = useState(clinicalManifestationsListParm);
    const [type, setType] = useState(null);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [idRowEditing, setIdRowEditing] = useState(undefined);

    useEffect(() => {
        setClinicalManifestationsList(clinicalManifestationsListParm);
    }, [clinicalManifestationsListParm]);

    function handleAddClinicalManifestation() {
        if (!isEditing) {
            const newClinicalManifestationItem = {
                id: (Math.floor(Math.random() * 65536)).toString(),
                type,
                month,
                year
            };

            const newClinicalManifestationsList = [...clinicalManifestationsList, newClinicalManifestationItem];
            setClinicalManifestationsList(newClinicalManifestationsList);
            onRequestAdd(newClinicalManifestationsList);
        } else {
            const newClinicalManifestationsList = clinicalManifestationsList.map(clinicalManifestationItem => {
                if (clinicalManifestationItem.id === idRowEditing) {
                    return {
                        id: clinicalManifestationItem.id,
                        type,
                        month,
                        year
                    }
                }

                return clinicalManifestationItem;
            })
            setClinicalManifestationsList(newClinicalManifestationsList);
            onRequestAdd(newClinicalManifestationsList);
        }

        resetFields();
    }

    function handleEditClinicalManifestation(id) {
        const editRowInfo = clinicalManifestationsList.find(x => x.id === id);
        if (editRowInfo) {
            setType(editRowInfo.type);
            setMonth(editRowInfo.month);
            setYear(editRowInfo.year);

            setIdRowEditing(id);
            setIsEditing(true);
        }
    }

    function handleDeleteClinicalManifestation(id) {
        const newClinicalManifestationsList = clinicalManifestationsList.filter(x => x.id !== id);
        setClinicalManifestationsList(newClinicalManifestationsList);
        onRequestAdd(newClinicalManifestationsList);
    }

    function resetFields() {
        setType(null);
        setMonth("");
        setYear("");

        setIsEditing(false);
        setIdRowEditing(undefined);
    }

    return (
        <>
            <DCard borderColor="light">
                <DCardHeader color="light" textColor="dark">Manifestações Clínicas</DCardHeader>
                <DCardBody>
                    <div className="basic-form">
                        <div className="row">
                            <div className="form-group mb-3 col-md-6">
                                <label><small>Selecione a manifestação</small></label>
                                <Select
                                    isClearable
                                    defaultValue={type}
                                    value={type}
                                    onChange={(e) => setType(e)}
                                    options={clinicManifestations}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            height: 45,
                                            backgroundColor: state.isDisabled ? "#dde0e3" : ""
                                        }),
                                    }}
                                    placeholder="Selecione..."
                                />
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <label><small>Mês</small></label>
                                <InputMask
                                    mask="99"
                                    maskChar=" "
                                    value={month}
                                    onChange={(event) => {
                                        if (event.target.value.length !== 2) return false;
                                        setMonth(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <label><small>Ano</small></label>
                                <InputMask
                                    mask="9999"
                                    maskChar=" "
                                    value={year}
                                    onChange={(event) => {
                                        if (event.target.value.length !== 4) return false;
                                        setYear(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <button className="btn btn-primary shadow mt-4 ms-1" onClick={handleAddClinicalManifestation}>
                                    <i className="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group mb-3 col-md-12" hidden={clinicalManifestationsList.length === 0}>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                <strong>Manifestação</strong>
                                            </th>
                                            <th>
                                                <strong>Mês</strong>
                                            </th>
                                            <th>
                                                <strong>Ano</strong>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            clinicalManifestationsList.map((clinicalManifestationItem) => {
                                                return (
                                                    <tr key={clinicalManifestationItem.id}>
                                                        <td>{clinicalManifestationItem.type.label}</td>
                                                        <td>{clinicalManifestationItem.month}</td>
                                                        <td>{clinicalManifestationItem.year}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    className="btn btn-info shadow sharp ms-1"
                                                                    onClick={() => handleEditClinicalManifestation(clinicalManifestationItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-danger shadow sharp ms-1"
                                                                    onClick={() => handleDeleteClinicalManifestation(clinicalManifestationItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </DCardBody>
            </DCard>
        </>
    )
}

ClinicalManifestationCard.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    //
    innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

ClinicalManifestationCard.defaultProps = {
    clinicalManifestationsListParm: []
};

export default ClinicalManifestationCard;